import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { TRACTION_TYPES } from 'apollo-client/queries/getAvailableTractionTypes';
import { tractionTypes } from 'cache';
import { Query, QueryGetAvailableTractionTypesArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const TractionTypeFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailabletractionTypes, { loading, data }] = useLazyQuery<Query, QueryGetAvailableTractionTypesArgs>(
    TRACTION_TYPES
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.tractionType.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.tractionType.placeholder' })}
        options={data?.getAvailableTractionTypes?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.tractionTypes?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailabletractionTypes({ variables: { inputTractionType: e } });
        }}
        onClick={(): void => {
          onGetAvailabletractionTypes({ variables: { inputTractionType: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          tractionTypes(x?.map(({ value }) => value) as string[]);
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
